import { validateVal } from "./numberMethods";
export default function summarize(val) {
    if (!validateVal(val === null || val === void 0 ? void 0 : val.valueOf())) {
        const negative = Number(val) < 0;
        val = Math.abs(Number(val));
        if (Number(val) > 999 && Number(val) < 99999) {
            val = Math.round(Number(val) / 10) / 100 + "K";
        }
        else if (Number(val) > 99999 && Number(val) < 9999999) {
            val = Math.round(Number(val) / 1000) / 100 + "L";
        }
        else if (Number(val) > 9999999) {
            val = Math.round(Number(val) / 100000) / 100 + "Cr";
        }
        else {
            val = Number(val) + "";
        }
        return negative ? "-" + val : val;
    }
    else {
        return "--";
    }
}
export function deSummarize(val) {
    if (typeof val === "string" || typeof val === "number") {
        let strVal = val.toString().trim();
        let isNegative = false;
        if (strVal.startsWith("-")) {
            isNegative = true;
            strVal = strVal.substring(1);
        }
        const suffixPattern = /(\d+(\.\d+)?)(K|L|Cr)/i;
        const match = strVal.match(suffixPattern);
        if (match) {
            let numPart = parseFloat(match[1]);
            let suffix = match[3].toUpperCase();
            switch (suffix) {
                case "K":
                    numPart *= 1000;
                    break;
                case "L":
                    numPart *= 100000;
                    break;
                case "CR":
                    numPart *= 10000000;
                    break;
                default:
                    return "--";
            }
            return isNegative ? -numPart : numPart;
        }
        else {
            // If no suffix found, return the number as is
            const numberValue = parseFloat(strVal);
            return isNegative ? -numberValue : numberValue;
        }
    }
    else {
        return "--"; // Invalid value
    }
}
